import { c as _c } from "react/compiler-runtime";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
export const useBack = () => {
  const $ = _c(2);
  const router = useCompatRouter();
  let t0;
  if ($[0] !== router) {
    const goBack = () => {
      if (window.history.length <= 1 || ["/review", "/category", "/landing"].some(path => router.pathname.startsWith(path))) {
        return window.location.replace("/");
      }
      if (["/shopping/[shopId]/voucher", "/payment/succeed/[id]"].includes(router.pathname)) {
        if (router.pathname === "/payment/succeed/[id]" || router.query.success === "true") {
          return window.history.go((window.history.length - 1) * -1);
        }
        if (window.history.length > 2) {
          return window.history.go(-2);
        }
      }
      return window.history.back();
    };
    t0 = {
      goBack
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};